import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, ModalController, Platform } from '@ionic/angular';
import { lastValueFrom } from 'rxjs';
import { MmOnboardingComponent } from 'src/app/components/mm-onboarding/mm-onboarding.component';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';
import { ModelLocatorService } from './model-locator.service';

@Injectable({
    providedIn: 'root'
})
export class OnboardService {

    constructor(private httpService: HttpService,
        public modelLocator: ModelLocatorService,
        public menuCtrl: MenuController,
        public modalCtrl: ModalController,
        public platform: Platform,
        public router: Router) { }

    async initOnboardingFlow(): Promise<any> {
        let onboardingFlow: any = [];

        let listIdPerfil = [8, 9, 10, 11];

        if (this.modelLocator.dadosLogin.embaixador) {
            onboardingFlow = [
                {
                    class: 'balao_1',
                    id: 1,
                    ballon: 'balao_1',
                    nextBalloon: 'balao_2',
                    menu: '',
                    router: '/ambassador',
                    pathImg: '../assets/image/onboarding/flow-3/balao_1.svg'
                },
                {
                    class: 'balao_1',
                    id: 2,
                    ballon: 'balao_2',
                    nextBalloon: 'balao_3',
                    menu: '',
                    router: '/ambassador',
                    pathImg: '../assets/image/onboarding/flow-3/balao_2.svg'
                },
                {
                    class: 'balao_1',
                    id: 3,
                    ballon: 'balao_3',
                    nextBalloon: 'balao_4',
                    menu: '',
                    router: '/home',
                    pathImg: '../assets/image/onboarding/flow-3/balao_3.svg'
                },
                {
                    class: 'balao_4',
                    id: 4,
                    ballon: 'balao_4',
                    nextBalloon: '',
                    menu: '',
                    router: '',
                    pathImg: '../assets/image/onboarding/flow-3/balao_4.svg'
                }
            ]
        } else if (this.modelLocator.dadosLogin.idperfil === 5 && this.modelLocator.dadosLogin.categoria_loja !== "DIAMANTE") {
            onboardingFlow = [
                {
                    class: 'balao_1',
                    id: 1,
                    ballon: 'balao_1',
                    nextBalloon: 'balao_2',
                    menu: 'end',
                    router: '/my-categories',
                    pathImg: '../assets/image/balao_1.svg'
                },
                {
                    class: 'balao_2',
                    id: 2,
                    ballon: 'balao_2',
                    nextBalloon: 'balao_3',
                    menu: 'start',
                    router: '',
                    pathImg: '../assets/image/balao_2.svg'
                },
                {
                    class: 'balao_3',
                    id: 3,
                    ballon: 'balao_3',
                    nextBalloon: 'balao_4',
                    menu: 'start',
                    router: '/my-points',
                    pathImg: '../assets/image/balao_3.svg'
                },
                {
                    class: 'balao_4',
                    id: 4,
                    ballon: 'balao_4',
                    nextBalloon: 'balao_5',
                    menu: '',
                    router: '/home',
                    pathImg: '../assets/image/balao_4.svg'
                },
                {
                    class: 'balao_5',
                    id: 5,
                    ballon: 'balao_5',
                    nextBalloon: '',
                    menu: '',
                    router: '/home',
                    pathImg: '../assets/image/balao_5.svg'
                }
            ]
        } else if (listIdPerfil.includes(this.modelLocator.dadosLogin.idperfil) && this.modelLocator.dadosLogin.categoria_loja !== "DIAMANTE") {
            onboardingFlow = [
                {
                    class: 'balao_1',
                    id: 1,
                    ballon: 'balao_1',
                    nextBalloon: 'balao_2',
                    menu: 'start',
                    router: '/my-points',
                    pathImg: '../assets/image/onboarding/flow-2/balao_1.svg'
                },
                {
                    class: 'balao_2',
                    id: 2,
                    ballon: 'balao_2',
                    nextBalloon: 'balao_3',
                    menu: '',
                    router: '/home',
                    pathImg: '../assets/image/onboarding/flow-2/balao_2.svg'
                },
                {
                    class: 'balao_3',
                    id: 3,
                    ballon: 'balao_3',
                    nextBalloon: '',
                    menu: '',
                    router: '',
                    pathImg: '../assets/image/onboarding/flow-2/balao_3.svg'
                }
            ]
        }

        if (onboardingFlow.length > 0 && (this.platform.is('android') || this.platform.is('ios'))) {
            await this.showOnboardingModal(onboardingFlow);
        }
    }

    async showOnboardingModal(onboardingFlow: any) {
        const modal = await this.modalCtrl.create({
            component: MmOnboardingComponent,
            cssClass: 'transparent-modal no-opacity',
            componentProps: { listOnboardingFlow: onboardingFlow },
        });

        await modal.present();
    }


    /**
     * Gets activation list
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async saveOnboard(configData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.POST_ONBOARDING, configData, config));
    }

    /**
     * Saves onboard challenge
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async saveOnboardChallenge() {

        const credenciais: any = {
            cpf: this.modelLocator.dadosLogin.cpf
        };

        let config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.POST_STATUS_READ_CHALLENGE, credenciais, config));
    }


}
